/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from 'react';

import {
  Sidebar,
  ISidebarProps,
  Topbar,
  ITopbarProps,
  Footer,
  IFooterProps,
} from './components';

import { Navigate } from 'react-router-dom';

export interface IRouteProps {
  component: any;
  notFoundLink?: string;
  abilityCheck?(): boolean;
  [key: string]: any;
}

export const SidebarWidget = ({
  component: Component,
  notFoundLink,
  abilityCheck,
  isShow,
  ...rest
}: IRouteProps & ISidebarProps & ITopbarProps & IFooterProps) => {
  const resize = () => {
    var resize = setInterval(() => {
      window.dispatchEvent(new Event('resize'));
    }, 10);
    setTimeout(function () {
      clearInterval(resize);
    }, 301);
  };

  const localStorageIsContracted = () => {
    const isContracted = localStorage.getItem('sidebarContracted');
    if (isContracted === null) {
      return false;
    } else {
      return isContracted !== 'false';
    }
  };

  const [contracted, setContracted] = useState(localStorageIsContracted());
  const [contractSidebar, setContractSidebar] = useState(
    localStorageIsContracted()
  );

  const toggleMouseOver = () => {
    if (contracted) {
      setContractSidebar(!contractSidebar);
    }
    resize();
  };

  const toggleContracted = () => {
    setContracted(!contracted);
    setContractSidebar(!contracted);
    localStorage.setItem('sidebarContracted', !contracted);
    resize();
  };

  const _renderMainComp = () => {
    return (
      <>
        <Sidebar
          contracted={contractSidebar}
          onMouseEnter={toggleMouseOver}
          onMouseLeave={toggleMouseOver}
          {...rest}
        />

        <main className="content">
          <Topbar toggleContracted={toggleContracted} {...rest} />
          <Component {...rest} />
          <Footer {...rest} />
        </main>
      </>
    );
  };

  if (abilityCheck) {
    const canRender = abilityCheck();
    if (canRender) {
      return _renderMainComp();
    }
    if (notFoundLink) {
      return <Navigate to={notFoundLink} replace={true} />;
    }
    return <></>;
  }
  return _renderMainComp();
};

SidebarWidget.defaultProps = {};
